module.exports = __webpack_public_path__ + "static/media/contract_sv_trans.457280c9.png";